module.exports = __webpack_public_path__ + "img/vegetarian.0a16744a.svg";